import { render } from "./AppMenuItem.vue?vue&type=template&id=74da31af&scoped=true"
import script from "./AppMenuItem.vue?vue&type=script&lang=js"
export * from "./AppMenuItem.vue?vue&type=script&lang=js"

import "./AppMenuItem.vue?vue&type=style&index=0&id=74da31af&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74da31af"]])

export default __exports__